// extracted by mini-css-extract-plugin
export default {"settings":"region-settings_settings__q23S5"};